import React, { useState, useEffect } from 'lib/react';
import {
  EVGrid,
  EVTextField,
  makeStyles,
} from 'lib/components';
import { useDispatch, useSelector } from 'lib/redux';
import { useTranslation } from 'lib/translation';
import { COMMENTS_MAX_LENGTH } from 'constants/AppConstants';
import FinalizeOrderExpansionPanel from './FinalizeOrderExpansionPanel.component';
import { updateSpecialInstructions } from '../FinalizeOrder.actions';

const useStyles = makeStyles(() => ({
  textarea: {
    '& textarea': { height: 'unset !important' },
  },
}));

function IncludeSpecialInstructions() {
  const classes = useStyles();
  const { comments } = useSelector((state) => state.placeOrder);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState('');
  const handleCommentsChange = ({ target: { value } }) => {
    if (value.length > COMMENTS_MAX_LENGTH) { setErrorMessage(t('maximum_length_exceeded')); }
    dispatch(updateSpecialInstructions(value));
  };
  const getPanelHeader = (header) => (<EVGrid>{header}</EVGrid>);
  useEffect(() => {
    if (comments?.length <= COMMENTS_MAX_LENGTH) setErrorMessage('');
  }, [comments]);
  return (
    <FinalizeOrderExpansionPanel
      panelSummary={getPanelHeader(t('finalize_order__include_special_instructions'))}
      defaultExpanded
    >
      <EVTextField
        id="comments"
        multiline
        variant="outlined"
        fullWidth
        minRows={3}
        classes={{ root: classes.textarea }}
        value={comments}
        onChange={handleCommentsChange}
        error={errorMessage}
        helperText={errorMessage}
      />
    </FinalizeOrderExpansionPanel>
  );
}

export default IncludeSpecialInstructions;
